import React from 'react';
import PropTypes from 'prop-types';

import HorizontalForm from 'components/form/horizontal_form';
import { COUNTRY_OPTIONS, stateFieldLabel, getStateOptions } from './country_state_list';

export default class ContactFields extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      address: PropTypes.shape({
        addressOne: PropTypes.string,
        addressTwo: PropTypes.string,
        city: PropTypes.string,
        countryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        countryNameOverride: PropTypes.string,
        id: PropTypes.number,
        label: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string
      }),
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      phoneNumber: PropTypes.string
    }),
    onChange: PropTypes.func.isRequired
  };

  state = {
    showAddressFields: !!this.props.contact.address.id
  }

  handleChange = (e) => {
    const { name, value } = e.target;

    this.props.onChange({ ...this.props.contact, [name]: value }, this.state.showAddressFields);
  }

  handleAddressChange = (e) => {
    const { name, value } = e.target;
    const { contact } = this.props;

    this.props.onChange({ ...contact, address: { ...contact.address, [name]: value } }, true);
  }

  toggleAddressFields = () => {
    const { onChange, contact } = this.props;

    this.setState((prevState) => {
      onChange({ ...contact, address: { ...contact.address } }, !prevState.showAddressFields);

      return { showAddressFields: !prevState.showAddressFields };
    });
  }

  renderAddressFields() {
    const { showAddressFields } = this.state;
    const { address } = this.props.contact;
    const stateOptions = getStateOptions(address.countryId);

    if (!showAddressFields) return;

    return (
      <React.Fragment>
        <HorizontalForm.TextInput
          label="Address Name"
          name="label"
          value={address.label}
          onChange={this.handleAddressChange}
        />

        <HorizontalForm.Select
          label="Country"
          name="countryId"
          options={COUNTRY_OPTIONS}
          value={address.countryId.toString()}
          onChange={this.handleAddressChange}
        />

        { address.countryId === 0 &&
          <HorizontalForm.TextInput
            name="countryNameOverride"
            required
            value={address.countryNameOverride}
            onChange={this.handleAddressChange}
          />
        }

        <HorizontalForm.TextInput
          label="Address Line 1"
          name="addressOne"
          value={address.addressOne}
          onChange={this.handleAddressChange}
        />

        <HorizontalForm.TextInput
          label="Address Line 2"
          name="addressTwo"
          value={address.addressTwo}
          onChange={this.handleAddressChange}
        />

        <HorizontalForm.TextInput
          name="city"
          value={address.city}
          onChange={this.handleAddressChange}
        />

        {stateOptions.length > 0 ?
          <HorizontalForm.Select
            label={stateFieldLabel(address.countryId.toString())}
            name="state"
            options={stateOptions}
            value={address.state}
            onChange={this.handleAddressChange}
          /> :
          <HorizontalForm.TextInput
            label={stateFieldLabel(address.countryId.toString())}
            name="state"
            value={address.state}
            onChange={this.handleAddressChange}
          />
        }

        <HorizontalForm.TextInput
          name="zip"
          value={address.zip}
          onChange={this.handleAddressChange}
        />
      </React.Fragment>
    );
  }

  render() {
    return (
      <div>
        <HorizontalForm>
          <HorizontalForm.TextInput
            label="Company Name"
            name="name"
            required
            value={this.props.contact.name}
            onChange={this.handleChange}
          />

          <HorizontalForm.TextInput
            name="email"
            value={this.props.contact.email}
            onChange={this.handleChange}
          />

          <HorizontalForm.TextInput
            name="phoneNumber"
            value={this.props.contact.phoneNumber}
            onChange={this.handleChange}
          />

          {!this.props.contact.address.id &&
            <HorizontalForm.Checkbox
              label="Add Primary Address"
              name="showAddressFields"
              value={this.state.showAddressFields}
              onChange={this.toggleAddressFields}
            />
          }

          { this.renderAddressFields() }
        </HorizontalForm>
      </div>
    );
  }
}
